import Vue from 'vue'
import hofTransformer from './../../transformers/hof'
import store from './../../store'

// When the request succeeds
const success = ([hofData, nameData]) => {
  store.dispatch('setHof', hofTransformer.fetch(hofData, nameData))
}

// When the request fails
const failed = () => {
}

const parsePPDBAthleteNames = (response) => {
  let names = {}
  const $doc = $($.parseXML(response.data))
  $doc.find('pingry-person').each((key, value) => {
    const $person = $(value)
    names[$person.find('constituent-id').text()] = $person.find('displayname').text();
  })
  return names
}

export default () => {
  const queryHof = 'media/?collectionId=491A1043-BADE-4E0F-B95175D2C04AD5F6&limit=1500'
  Vue.Promise.all([
    Vue.http.get(queryHof).then(response => response.json()),
    Vue.http.get(process.env.PPDB_API_LOCATION + '/cgi-bin/athleticshalloffame').then(parsePPDBAthleteNames).catch(failed),
  ]).then(success)
    .catch(failed)
}
